import { FooterLink } from "../interfaces/footer-link";

export const FOOTER_PARTNERS: Array<{name: string, link?: string}> = [
    {
        name:'parentalResp_fr',
        link: 'https://www.lonaci.ci/politique-de-jeu-responsable/'
    },
    {
        name:'gamban',
        link: 'https://gamban.com/fr'
    },
    // {
    //   name:'DiZaPay',
    // },
    {
      name: 'LONAPAY'
    },
    {
      name:'ORANGE',
    },
    {
      name:'MOOV',
    },
    {
      name:'mobile-money',
    },
    // {
    //   name:'VISAUBA',
    // },
    {
      name: 'WAVE',
    },
  ];

export const FOOTER_ABOUT_MENUS: Array<FooterLink> = [
    {
      name: 'about',
      id: 'about',
      link: 'rules-page'
    },
    {
      name: "privacy_policy",
      id: "privacy-policy",
      link: "rules-page",
    }
  ];

export const FOOTER_INFO_MENUS: Array<FooterLink> = [
    {
      name: 'notice',
      id: 'terms-and-conditions',
      link: 'rules-page'
    },
    {
      name: 'responsible_gambling',
      id: 'play-responsibly',
      // link: 'rules-page'
      link: 'https://www.lonaci.ci/politique-de-jeu-responsable/'
    },
    {
      name: "cookies_policy",
      id: "cookies-policy",
      link: "rules-page",
    },
    {
      name: "personal_data_policy",
      id: "personal-data-policy",
      link: "rules-page",
    },
  ];

export const FOOTER_AIDE_MENUS: Array<FooterLink> = [
    {
      name: 'ml_contacts',
      id: 'contact-us',
      link: 'rules-page'
    },
    // {
    //   name: 'how_to',
    //   id: 'how-to',
    //   link: 'rules-page',
    // },
    {
      name: "promotions",
      id: "promotions",
      link: 'rules-page',
    },
  ];
